document.addEventListener("DOMContentLoaded", function () {
  const configurators = document.querySelectorAll(".rental-configurator");

  configurators.forEach((configurator) => {
    const sectionId = configurator.dataset.sectionId;
    const deliveryCategory = configurator.dataset.deliveryCategory || "standard_truck";
    const defaultDriveMinutes = Number(configurator.dataset.defaultDriveMinutes || 5);
    const isLoggedIn = configurator.dataset.isLoggedInCustomer === "true";
    const storageKey = `rental-configurator-state-${sectionId}`;
    const rentalRates = {
      halfDay: centsToRate(configurator.dataset.rateHalfDayCents, 75),
      day: centsToRate(configurator.dataset.rateDayCents, 45),
      week: centsToRate(configurator.dataset.rateWeekCents, 155),
      fourWeek: centsToRate(configurator.dataset.rateFourWeekCents, 465)
    };

    const steps = Array.from(configurator.querySelectorAll(".rc-step"));
    const progressItems = configurator.querySelectorAll(".rc-progress__item");
    const prevBtn = configurator.querySelector('[data-rc-action="prev"]');
    const nextBtn = configurator.querySelector('[data-rc-action="next"]');
    const submitBtn = configurator.querySelector(".rc-btn--submit");
    const saveRentalDetailsBtn = configurator.querySelector("[data-save-rental-details]");
    const form = configurator.querySelector("form");

    const dateManualInput = configurator.querySelector(`#rc-date-manual-${sectionId}`);
    const timeManualInput = configurator.querySelector(`#rc-time-manual-${sectionId}`);
    const customStartInput = configurator.querySelector(`#rc-custom-start-${sectionId}`);
    const customEndInput = configurator.querySelector(`#rc-custom-end-${sectionId}`);

    const requestedDateDisplay = configurator.querySelector("[data-requested-date-display]");
    const requestedDatePanel = configurator.querySelector("[data-date-picker-panel]");
    const deliverySummary = configurator.querySelector("[data-delivery-summary]");
    const deliveryTypeEl = configurator.querySelector("[data-delivery-type]");
    const deliveryDistanceEl = configurator.querySelector("[data-delivery-distance]");
    const deliveryPriceEl = configurator.querySelector("[data-delivery-price-display]");
    const deliverySplitEl = configurator.querySelector("[data-delivery-split]");
    const deliveryNoteEl = configurator.querySelector("[data-delivery-note]");
    const pickupNoteEl = configurator.querySelector("[data-pickup-note]");

    const overnightPanel = configurator.querySelector("[data-overnight-panel]");
    const overnightKeepBtn = configurator.querySelector("[data-overnight-keep]");
    const overnightReturnBtn = configurator.querySelector("[data-overnight-return]");
    const overnightRateEl = configurator.querySelector("[data-overnight-rate]");

    const rentalPeriodCard = configurator.querySelector("[data-rental-period]");
    const rentalPeriodStartDate = configurator.querySelector("[data-period-start-date]");
    const rentalPeriodStartTime = configurator.querySelector("[data-period-start-time]");
    const rentalPeriodEndDate = configurator.querySelector("[data-period-end-date]");
    const rentalPeriodEndTime = configurator.querySelector("[data-period-end-time]");
    const rentalPeriodNote = configurator.querySelector("[data-period-note]");

    const customDatesToggle = configurator.querySelector("[data-custom-dates-toggle]");
    const customDatesPanel = configurator.querySelector("[data-custom-dates-panel]");

    const sidePickupDate = configurator.querySelector(`#rc-side-pickup-date-${sectionId}`);
    const sidePickupTime = configurator.querySelector(`#rc-side-pickup-time-${sectionId}`);
    const sideReturnDate = configurator.querySelector(`#rc-side-return-date-${sectionId}`);
    const sideReturnTime = configurator.querySelector(`#rc-side-return-time-${sectionId}`);
    const sideCalcButton = configurator.querySelector("[data-calc-custom-price]");
    const sideCalcResult = configurator.querySelector("[data-calc-result]");
    const sideCalcPrice = configurator.querySelector("[data-calc-price]");
    const sideCalcDuration = configurator.querySelector("[data-calc-duration]");
    const sideCalcCta = configurator.querySelector("[data-calc-cta]");

    const loginModal = document.getElementById(`rental-configurator-modal-${sectionId}`);

    const existingPanel = configurator.querySelector('[data-customer-panel="existing"]');
    const existingSummary = configurator.querySelector("[data-existing-summary]");
    const existingEdit = configurator.querySelector("[data-existing-edit]");
    const existingEditToggle = configurator.querySelector("[data-existing-edit-toggle]");
    const existingSaveBtn = configurator.querySelector("[data-existing-save]");
    const existingCancelBtn = configurator.querySelector("[data-existing-cancel]");
    const existingSummaryName = configurator.querySelector("[data-existing-summary-name]");
    const existingSummaryEmail = configurator.querySelector("[data-existing-summary-email]");
    const existingSummaryPhone = configurator.querySelector("[data-existing-summary-phone]");
    const existingSummaryAddress = configurator.querySelector("[data-existing-summary-address]");

    const existingFields = {
      firstName: configurator.querySelector(`#rc-existing-first-name-${sectionId}`),
      lastName: configurator.querySelector(`#rc-existing-last-name-${sectionId}`),
      email: configurator.querySelector(`#rc-existing-email-${sectionId}`),
      phone: configurator.querySelector(`#rc-existing-phone-${sectionId}`),
      address1: configurator.querySelector(`#rc-existing-address1-${sectionId}`),
      city: configurator.querySelector(`#rc-existing-city-${sectionId}`),
      state: configurator.querySelector(`#rc-existing-state-${sectionId}`),
      zip: configurator.querySelector(`#rc-existing-zip-${sectionId}`)
    };

    const newCustomerFields = {
      firstName: configurator.querySelector(`#rc-first-name-${sectionId}`),
      lastName: configurator.querySelector(`#rc-last-name-${sectionId}`),
      email: configurator.querySelector(`#rc-email-${sectionId}`),
      phone: configurator.querySelector(`#rc-phone-${sectionId}`),
      address1: configurator.querySelector(`#rc-home-address-${sectionId}`),
      city: configurator.querySelector(`#rc-city-${sectionId}`),
      state: configurator.querySelector(`#rc-state-${sectionId}`),
      zip: configurator.querySelector(`#rc-zip-${sectionId}`)
    };

    const homeAddressPreview = configurator.querySelector("[data-home-address-preview]");
    const homeDestinationPanel = configurator.querySelector('[data-destination-panel="home"]');
    const jobsitePanel = configurator.querySelector('[data-destination-panel="jobsite"]');
    const homeContactToggle = configurator.querySelector("[data-home-contact-toggle]");
    const homeContactPanel = configurator.querySelector("[data-home-contact-panel]");
    const onsiteSameInput = configurator.querySelector(`#rc-onsite-same-${sectionId}`);

    const onsiteFields = {
      firstName: configurator.querySelector(`#rc-onsite-first-name-${sectionId}`),
      lastName: configurator.querySelector(`#rc-onsite-last-name-${sectionId}`),
      phone: configurator.querySelector(`#rc-onsite-phone-${sectionId}`)
    };

    const onsiteHiddenFields = {
      firstName: configurator.querySelector(`#rc-onsite-first-name-hidden-${sectionId}`),
      lastName: configurator.querySelector(`#rc-onsite-last-name-hidden-${sectionId}`),
      phone: configurator.querySelector(`#rc-onsite-phone-hidden-${sectionId}`)
    };

    let currentStep = 1;
    const answers = {
      "need-type": "This Is All I Need",
      "overnight-option": "same-day",
      "custom-duration-mode": "preset"
    };

    function getModal() {
      return loginModal;
    }

    function openModal() {
      const modal = getModal();
      if (!modal) return;
      persistState();
      modal.hidden = false;
      document.body.classList.add("rental-modal-open");
    }

    function closeModal() {
      const modal = getModal();
      if (!modal) return;
      modal.hidden = true;
      document.body.classList.remove("rental-modal-open");
    }

    function safeJsonParse(value) {
      try {
        return JSON.parse(value);
      } catch (error) {
        return null;
      }
    }

    function centsToRate(value, fallback) {
      const cents = Number(value);
      if (!Number.isFinite(cents) || cents <= 0) return fallback;
      return cents / 100;
    }

    function formatMoney(value) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(value);
    }

    function persistState() {
      if (!form) return;

      const fieldValues = {};
      form.querySelectorAll("input, select, textarea").forEach((field) => {
        if (!field.name && !field.id) return;
        if (field.type === "password") return;
        const key = field.id || field.name;
        fieldValues[key] = field.type === "checkbox" ? field.checked : field.value;
      });

      const payload = {
        currentStep,
        answers,
        fieldValues
      };

      sessionStorage.setItem(storageKey, JSON.stringify(payload));
    }

    function restoreState() {
      const raw = sessionStorage.getItem(storageKey);
      const saved = safeJsonParse(raw);
      if (!saved) return;

      if (saved.answers && typeof saved.answers === "object") {
        Object.keys(saved.answers).forEach((key) => {
          answers[key] = saved.answers[key];
        });
      }

      if (saved.fieldValues && typeof saved.fieldValues === "object") {
        Object.entries(saved.fieldValues).forEach(([key, value]) => {
          const field = form.querySelector(`#${CSS.escape(key)}`) || form.querySelector(`[name="${CSS.escape(key)}"]`);
          if (!field) return;
          if (field.type === "checkbox") {
            field.checked = Boolean(value);
          } else {
            field.value = value;
          }
        });
      }

      if (saved.currentStep) {
        currentStep = Number(saved.currentStep) || 1;
      }
    }

    function updateProgress() {
      progressItems.forEach((item, index) => {
        item.classList.toggle("is-active", index < currentStep);
      });
    }

    function updateButtons() {
      if (prevBtn) {
        prevBtn.style.display = currentStep > 1 ? "inline-flex" : "none";
      }

      if (currentStep === steps.length) {
        if (nextBtn) nextBtn.style.display = "none";
        if (submitBtn) submitBtn.hidden = false;
      } else {
        if (nextBtn) nextBtn.style.display = "inline-flex";
        if (submitBtn) submitBtn.hidden = true;
      }
    }

    function renderSteps() {
      steps.forEach((step, index) => {
        const stepNumber = index + 1;
        step.classList.remove("is-open", "is-complete");

        if (stepNumber < currentStep) {
          step.classList.add("is-complete");
        } else if (stepNumber === currentStep) {
          step.classList.add("is-open");
        }
      });

      updateProgress();
      updateButtons();
      persistState();
    }

    function goToStep(stepNumber) {
      currentStep = Math.max(1, Math.min(stepNumber, steps.length));
      renderSteps();

      const activeStep = configurator.querySelector(`.rc-step[data-step="${currentStep}"]`);
      if (activeStep) {
        activeStep.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }

    function getPropertyInput(key) {
      return configurator.querySelector(`#${key}-${sectionId}`);
    }

    function saveProperty(group, value) {
      const mapping = {
        "need-type": "rc-need-type",
        "receive-method": "rc-receive-method",
        "customer-type": "rc-customer-type",
        "equipment-destination": "rc-equipment-destination",
        "requested-date": "rc-requested-date",
        "requested-time": "rc-requested-time",
        "rental-duration": "rc-rental-duration",
        "delivery-type": "rc-delivery-type",
        "distance": "rc-distance",
        "delivery-price": "rc-delivery-price",
        "overnight-option": "rc-overnight-option"
      };

      const inputId = mapping[group];
      if (!inputId) return;

      const input = getPropertyInput(inputId);
      if (input) input.value = value;
    }

    function setSelected(group, clickedOption) {
      const groupItems = configurator.querySelectorAll(`[data-group="${group}"]`);
      groupItems.forEach((item) => item.classList.remove("is-selected"));
      clickedOption.classList.add("is-selected");
    }

    function selectOptionByValue(group, value) {
      const option = configurator.querySelector(`[data-group="${group}"][data-value="${CSS.escape(value)}"]`);
      if (!option) return;
      setSelected(group, option);
      answers[group] = value;
      saveProperty(group, value);
      handleConditionalPanels(group, value);
    }

    function autoAdvanceFrom(group) {
      if (!["need-type", "receive-method"].includes(group)) return;

      const selected = configurator.querySelector(`[data-group="${group}"].is-selected`);
      if (!selected) return;

      const stepEl = selected.closest(".rc-step");
      if (!stepEl) return;

      const stepNumber = parseInt(stepEl.dataset.step, 10);
      if (!Number.isNaN(stepNumber) && stepNumber < steps.length) {
        setTimeout(() => {
          goToStep(stepNumber + 1);
        }, 180);
      }
    }

    function formatDateForInput(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }

    function formatDateLong(date) {
      return date.toLocaleDateString("en-US", {
        weekday: "long",
        month: "long",
        day: "numeric",
        year: "numeric"
      });
    }

    function formatDateShort(date) {
      return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric"
      });
    }

    function formatTimeDisplay(date) {
      return date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit"
      });
    }

    function parseTimeTo24Hour(timeString) {
      if (!timeString || timeString === "Select time") return null;

      const parts = timeString.match(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/i);
      if (!parts) return null;

      let hours = parseInt(parts[1], 10);
      const minutes = parseInt(parts[2], 10);
      const period = parts[3].toUpperCase();

      if (period === "PM" && hours !== 12) hours += 12;
      if (period === "AM" && hours === 12) hours = 0;

      return { hours, minutes };
    }

    function getSelectedRequestedDate() {
      const selectedDateOption = answers["requested-date"] || "";
      const manualDate = dateManualInput?.value || "";
      const today = new Date();
      const tomorrow = new Date();
      tomorrow.setDate(today.getDate() + 1);

      if (selectedDateOption === "Today") return formatDateForInput(today);
      if (selectedDateOption === "Tomorrow") return formatDateForInput(tomorrow);
      if (selectedDateOption === "Pick a Day" && manualDate) return manualDate;
      if (manualDate) return manualDate;

      return "";
    }

    function getRequestedDateObject() {
      const dateValue = getSelectedRequestedDate();
      if (!dateValue) return null;
      return new Date(`${dateValue}T00:00:00`);
    }

    function buildDateTime(dateValue, timeValue) {
      if (!dateValue) return null;
      const time = parseTimeTo24Hour(timeValue);
      if (!time) return null;

      const date = new Date(`${dateValue}T00:00:00`);
      date.setHours(time.hours, time.minutes, 0, 0);
      return date;
    }

    function getRequestedDateTime() {
      const dateValue = getSelectedRequestedDate();
      const timeValue = timeManualInput?.value || "";
      return buildDateTime(dateValue, timeValue);
    }

    function syncRequestedDate() {
      const finalDate = getSelectedRequestedDate();
      saveProperty("requested-date", finalDate);

      const dateObject = getRequestedDateObject();
      if (requestedDateDisplay) {
        requestedDateDisplay.textContent = dateObject
          ? formatDateLong(dateObject)
          : "Select a requested delivery date";
      }
    }

    function syncRequestedTime() {
      saveProperty("requested-time", timeManualInput?.value || "");
    }

    function getDeliveryPricing(category, driveMinutes) {
      const pricing = {
        standard_truck: {
          label: "Standard Truck/Trailer",
          bands: [
            { max: 45, price: 85 },
            { max: 75, price: 125 }
          ]
        },
        dual_load: {
          label: "Dual Load",
          bands: [
            { max: 45, price: 125 },
            { max: 75, price: 200 }
          ]
        },
        scissor: {
          label: "Scissor Lift",
          bands: [
            { max: 45, price: 125 },
            { max: 75, price: 200 }
          ]
        },
        heavy_iron: {
          label: "Heavy Iron",
          bands: [
            { max: 45, price: 350 },
            { max: 75, price: 450 }
          ]
        }
      };

      const config = pricing[category] || pricing.standard_truck;

      if (driveMinutes >= 76) {
        return {
          type: config.label,
          total: null,
          totalDisplay: "Manual Review Required",
          deliveryHalf: "",
          pickupHalf: "",
          distanceDisplay: `${driveMinutes} minutes`
        };
      }

      const band = config.bands.find((item) => driveMinutes <= item.max);
      const total = band ? band.price : null;

      return {
        type: config.label,
        total,
        totalDisplay: total !== null ? `$${total.toFixed(2)}` : "Manual Review Required",
        deliveryHalf: total !== null ? `$${(total / 2).toFixed(2)} Delivery` : "",
        pickupHalf: total !== null ? `$${(total / 2).toFixed(2)} Pickup` : "",
        distanceDisplay: `${driveMinutes} minutes`
      };
    }

    function updateDeliverySummary() {
      const receiveMethod = answers["receive-method"] || "";
      const pricing = getDeliveryPricing(deliveryCategory, defaultDriveMinutes);

      if (receiveMethod === "Customer Pickup") {
        if (deliverySummary) deliverySummary.hidden = true;
        if (pickupNoteEl) pickupNoteEl.hidden = false;
        saveProperty("delivery-type", "");
        saveProperty("distance", "");
        saveProperty("delivery-price", "");
        return;
      }

      if (deliverySummary) deliverySummary.hidden = false;
      if (pickupNoteEl) pickupNoteEl.hidden = true;

      if (deliveryTypeEl) deliveryTypeEl.textContent = pricing.type;
      if (deliveryDistanceEl) deliveryDistanceEl.textContent = pricing.distanceDisplay;
      if (deliveryPriceEl) deliveryPriceEl.textContent = pricing.totalDisplay;
      if (deliverySplitEl) {
        deliverySplitEl.textContent = pricing.total !== null
          ? `(${pricing.deliveryHalf} + ${pricing.pickupHalf})`
          : "Quoted after manual review";
      }
      if (deliveryNoteEl) {
        deliveryNoteEl.textContent = pricing.total !== null
          ? "Price includes delivery to site and pickup when rental period ends"
          : "76+ minutes requires manual review before quoting";
      }

      saveProperty("delivery-type", pricing.type);
      saveProperty("distance", pricing.distanceDisplay);
      saveProperty("delivery-price", pricing.totalDisplay);
    }

    function isOvernightEligible() {
      const rentalDuration = answers["rental-duration"];
      const requestedTime = timeManualInput?.value || "";
      const parsedTime = parseTimeTo24Hour(requestedTime);

      if (answers["custom-duration-mode"] === "custom") return false;
      if (rentalDuration !== "1/2 Day" || !parsedTime) return false;

      const totalMinutes = parsedTime.hours * 60 + parsedTime.minutes;
      return totalMinutes >= 16 * 60;
    }

    function updateOvernightPanel() {
      const show = isOvernightEligible();
      const halfDayRate = rentalRates.halfDay;

      if (overnightPanel) overnightPanel.hidden = !show;
      if (overnightRateEl) overnightRateEl.textContent = formatMoney(halfDayRate);

      if (!show) {
        answers["overnight-option"] = "same-day";
        saveProperty("overnight-option", "Same-Day Return");
        overnightKeepBtn?.classList.add("is-selected");
        overnightReturnBtn?.classList.remove("is-selected");
      }
    }

    function addDuration(date, durationValue) {
      const next = new Date(date.getTime());

      if (durationValue === "Day") {
        next.setDate(next.getDate() + 1);
        return next;
      }

      if (durationValue === "Week") {
        next.setDate(next.getDate() + 7);
        return next;
      }

      if (durationValue === "4 Weeks") {
        next.setDate(next.getDate() + 28);
        return next;
      }

      return next;
    }

    function updateCustomDatesPanel() {
      const isCustom = answers["custom-duration-mode"] === "custom";

      if (customDatesPanel) customDatesPanel.hidden = !isCustom;
      if (customDatesToggle) {
        customDatesToggle.classList.toggle("is-selected", isCustom);
        customDatesToggle.textContent = isCustom ? "Hide Custom Dates" : "Use Custom Dates";
      }

      if (isCustom) {
        saveProperty("rental-duration", "Custom Dates");
      } else if (answers["rental-duration"]) {
        saveProperty("rental-duration", answers["rental-duration"]);
      }
    }

    function updateRentalPeriod() {
      const requestedDateTime = getRequestedDateTime();

      if (!requestedDateTime) {
        if (rentalPeriodCard) rentalPeriodCard.hidden = true;
        return;
      }

      let start;
      let end;
      let note = "";

      if (answers["custom-duration-mode"] === "custom") {
        if (!customStartInput?.value || !customEndInput?.value) {
          if (rentalPeriodCard) rentalPeriodCard.hidden = true;
          return;
        }

        start = new Date(`${customStartInput.value}T08:00:00`);
        end = new Date(`${customEndInput.value}T17:00:00`);
        note = "Custom rental dates selected";

        if (end.getTime() < start.getTime()) {
          if (rentalPeriodCard) rentalPeriodCard.hidden = true;
          return;
        }
      } else {
        const rentalDuration = answers["rental-duration"] || "";
        if (!rentalDuration) {
          if (rentalPeriodCard) rentalPeriodCard.hidden = true;
          return;
        }

        start = new Date(requestedDateTime.getTime());
        end = new Date(requestedDateTime.getTime());

        if (rentalDuration === "1/2 Day") {
          if (answers["overnight-option"] === "overnight" && isOvernightEligible()) {
            end.setDate(end.getDate() + 1);
            end.setHours(9, 0, 0, 0);
            note = "Overnight rate applied • Return by 9:00 AM";
          } else {
            end.setHours(18, 0, 0, 0);
            note = "Extended to closing time (6:00 PM) • Still 1-4 hour rate";
          }
        } else {
          end = addDuration(end, rentalDuration);
          note = `${rentalDuration} rental period selected`;
        }
      }

      if (rentalPeriodCard) rentalPeriodCard.hidden = false;
      if (rentalPeriodStartDate) rentalPeriodStartDate.textContent = formatDateShort(start);
      if (rentalPeriodStartTime) rentalPeriodStartTime.textContent = formatTimeDisplay(start);
      if (rentalPeriodEndDate) rentalPeriodEndDate.textContent = formatDateShort(end);
      if (rentalPeriodEndTime) rentalPeriodEndTime.textContent = formatTimeDisplay(end);
      if (rentalPeriodNote) rentalPeriodNote.textContent = note;
    }

    function getExistingAccountData() {
      return {
        firstName: existingFields.firstName?.value?.trim() || "",
        lastName: existingFields.lastName?.value?.trim() || "",
        email: existingFields.email?.value?.trim() || "",
        phone: existingFields.phone?.value?.trim() || "",
        address1: existingFields.address1?.value?.trim() || "",
        city: existingFields.city?.value?.trim() || "",
        state: existingFields.state?.value?.trim() || "",
        zip: existingFields.zip?.value?.trim() || ""
      };
    }

    function getNewCustomerData() {
      return {
        firstName: newCustomerFields.firstName?.value?.trim() || "",
        lastName: newCustomerFields.lastName?.value?.trim() || "",
        email: newCustomerFields.email?.value?.trim() || "",
        phone: newCustomerFields.phone?.value?.trim() || "",
        address1: newCustomerFields.address1?.value?.trim() || "",
        city: newCustomerFields.city?.value?.trim() || "",
        state: newCustomerFields.state?.value?.trim() || "",
        zip: newCustomerFields.zip?.value?.trim() || ""
      };
    }

    function buildAddressLine(data) {
      const parts = [data.address1, data.city, data.state].filter(Boolean);
      let line = parts.join(", ");
      if (data.zip) {
        line = line ? `${line} ${data.zip}` : data.zip;
      }
      return line || "Use saved home address";
    }

    function updateExistingSummary() {
      if (!existingSummary) return;
      const data = getExistingAccountData();

      if (existingSummaryName) {
        existingSummaryName.textContent = [data.firstName, data.lastName].filter(Boolean).join(" ") || "Add your name";
      }

      if (existingSummaryEmail) {
        existingSummaryEmail.textContent = data.email || "Add your email";
      }

      if (existingSummaryPhone) {
        existingSummaryPhone.textContent = data.phone || "Add your phone";
      }

      if (existingSummaryAddress) {
        existingSummaryAddress.textContent = buildAddressLine(data);
      }
    }

    function updateHomeAddressPreview() {
      const customerType = answers["customer-type"] || "";
      const data = customerType === "Existing Customer" ? getExistingAccountData() : getNewCustomerData();
      if (homeAddressPreview) {
        homeAddressPreview.textContent = buildAddressLine(data);
      }
    }

    function syncOnsiteContactHiddenFields() {
      const sameAsAccount = homeContactToggle?.classList.contains("is-selected");

      if (sameAsAccount) {
        if (onsiteHiddenFields.firstName) onsiteHiddenFields.firstName.value = "";
        if (onsiteHiddenFields.lastName) onsiteHiddenFields.lastName.value = "";
        if (onsiteHiddenFields.phone) onsiteHiddenFields.phone.value = "";
        return;
      }

      if (onsiteHiddenFields.firstName) onsiteHiddenFields.firstName.value = onsiteFields.firstName?.value?.trim() || "";
      if (onsiteHiddenFields.lastName) onsiteHiddenFields.lastName.value = onsiteFields.lastName?.value?.trim() || "";
      if (onsiteHiddenFields.phone) onsiteHiddenFields.phone.value = onsiteFields.phone?.value?.trim() || "";
    }

    function syncOnsiteContactState() {
      const sameAsAccount = homeContactToggle?.classList.contains("is-selected");
      if (onsiteSameInput) onsiteSameInput.value = sameAsAccount ? "Yes" : "No";
      if (homeContactPanel) homeContactPanel.hidden = Boolean(sameAsAccount);
      syncOnsiteContactHiddenFields();
    }

    function handleConditionalPanels(group, value) {
      if (group === "customer-type") {
        const newPanel = configurator.querySelector('[data-customer-panel="new"]');

        if (newPanel) newPanel.hidden = value !== "New Customer";
        if (existingPanel) existingPanel.hidden = value !== "Existing Customer";
        updateHomeAddressPreview();
      }

      if (group === "equipment-destination") {
        if (jobsitePanel) jobsitePanel.hidden = value !== "Job Site Address";
        if (homeDestinationPanel) homeDestinationPanel.hidden = value !== "Home Address";
      }

      if (group === "requested-date" && requestedDatePanel) {
        requestedDatePanel.hidden = value !== "Pick a Day";
      }
    }

    function validateCurrentStep() {
      const activeStep = configurator.querySelector(`.rc-step[data-step="${currentStep}"]`);
      if (!activeStep) return true;

      if (currentStep === 3) {
        const customerType = answers["customer-type"];
        if (!customerType) return false;

        if (customerType === "Existing Customer" && !isLoggedIn) {
          openModal();
          return false;
        }

        if (customerType === "New Customer") {
          const requiredFields = [
            newCustomerFields.firstName,
            newCustomerFields.lastName,
            newCustomerFields.email,
            newCustomerFields.phone,
            newCustomerFields.address1,
            newCustomerFields.city,
            newCustomerFields.state,
            newCustomerFields.zip,
            configurator.querySelector(`#rc-password-${sectionId}`)
          ];

          const invalid = requiredFields.find((field) => !field?.value?.trim());
          if (invalid) {
            invalid.focus();
            return false;
          }
        }
      }

      if (currentStep === 4) {
        const destination = answers["equipment-destination"];
        if (!destination) return false;

        if (destination === "Job Site Address") {
          const jobFields = [
            configurator.querySelector(`#rc-jobsite-address-${sectionId}`),
            configurator.querySelector(`#rc-jobsite-city-${sectionId}`),
            configurator.querySelector(`#rc-jobsite-state-${sectionId}`),
            configurator.querySelector(`#rc-jobsite-zip-${sectionId}`)
          ];

          const invalidJobField = jobFields.find((field) => !field?.value?.trim());
          if (invalidJobField) {
            invalidJobField.focus();
            return false;
          }
        }

        if (destination === "Home Address") {
          const customerType = answers["customer-type"];
          const addressLine = buildAddressLine(customerType === "Existing Customer" ? getExistingAccountData() : getNewCustomerData());
          if (addressLine === "Use saved home address") {
            alert("Please add the home address information first.");
            return false;
          }

          const sameAsAccount = homeContactToggle?.classList.contains("is-selected");
          if (!sameAsAccount) {
            const invalidOnsite = Object.values(onsiteFields).find((field) => !field?.value?.trim());
            if (invalidOnsite) {
              invalidOnsite.focus();
              return false;
            }
          }
        }
      }

      if (currentStep === 5) {
        if (!answers["requested-date"]) return false;
        if (!(timeManualInput && timeManualInput.value)) {
          timeManualInput?.focus();
          return false;
        }
      }

      if (currentStep === 6) {
        if (answers["custom-duration-mode"] === "custom") {
          if (!customStartInput?.value) {
            customStartInput?.focus();
            return false;
          }

          if (!customEndInput?.value) {
            customEndInput?.focus();
            return false;
          }
        } else if (!answers["rental-duration"]) {
          return false;
        }
      }

      if ([1, 2].includes(currentStep) && activeStep.querySelector(".rc-option") && !activeStep.querySelector(".rc-option.is-selected")) {
        return false;
      }

      return true;
    }

    function validateExistingAccountEdit() {
      if (!existingFields.firstName?.value.trim()) return existingFields.firstName;
      if (!existingFields.lastName?.value.trim()) return existingFields.lastName;
      if (!existingFields.email?.value.trim()) return existingFields.email;
      if (!existingFields.phone?.value.trim()) return existingFields.phone;
      if (!existingFields.address1?.value.trim()) return existingFields.address1;
      if (!existingFields.city?.value.trim()) return existingFields.city;
      if (!existingFields.state?.value.trim()) return existingFields.state;
      if (!existingFields.zip?.value.trim()) return existingFields.zip;
      return null;
    }

    function formatDuration(totalHours) {
      const fullDays = Math.floor(totalHours / 24);
      const remainingHours = totalHours - fullDays * 24;
      const roundedHours = Math.round(remainingHours * 10) / 10;

      if (fullDays > 0 && roundedHours > 0) {
        return `${fullDays} day${fullDays === 1 ? "" : "s"} + ${roundedHours} hrs`;
      }

      if (fullDays > 0) {
        return `${fullDays} day${fullDays === 1 ? "" : "s"}`;
      }

      return `${roundedHours} hrs`;
    }

    function calculateCustomRentalPrice(totalHours) {
      const halfDayRate = rentalRates.halfDay;
      const dayRate = rentalRates.day;
      const weekRate = rentalRates.week;
      const fourWeekRate = rentalRates.fourWeek;
      const fourWeekHours = 28 * 24;
      const weekHours = 7 * 24;

      if (totalHours <= 4) return halfDayRate;

      let remainingHours = totalHours;
      let total = 0;

      if (remainingHours >= fourWeekHours) {
        const fourWeekBlocks = Math.floor(remainingHours / fourWeekHours);
        total += fourWeekBlocks * fourWeekRate;
        remainingHours -= fourWeekBlocks * fourWeekHours;
      }

      if (remainingHours >= weekHours) {
        const weekBlocks = Math.floor(remainingHours / weekHours);
        total += weekBlocks * weekRate;
        remainingHours -= weekBlocks * weekHours;
      }

      if (remainingHours > 0) {
        if (remainingHours <= 4) {
          total += halfDayRate;
        } else {
          total += (remainingHours / 24) * dayRate;
        }
      }

      return Math.round(total * 100) / 100;
    }

    function showCalcError(message) {
      if (!sideCalcResult || !sideCalcPrice || !sideCalcDuration) return;
      sideCalcResult.hidden = false;
      sideCalcResult.classList.add("is-error");
      sideCalcPrice.textContent = message;
      sideCalcDuration.textContent = "";
    }

    function showCalcSuccess(price, durationText) {
      if (!sideCalcResult || !sideCalcPrice || !sideCalcDuration) return;
      sideCalcResult.hidden = false;
      sideCalcResult.classList.remove("is-error");
      sideCalcPrice.textContent = formatMoney(price);
      sideCalcDuration.textContent = durationText;
    }

    function runCustomCalculator() {
      const pickupDateTime = buildDateTime(sidePickupDate?.value, sidePickupTime?.value);
      const returnDateTime = buildDateTime(sideReturnDate?.value, sideReturnTime?.value);

      if (!pickupDateTime || !returnDateTime) {
        showCalcError("Select pickup and return date/time.");
        return;
      }

      const diffMs = returnDateTime.getTime() - pickupDateTime.getTime();
      const totalHours = diffMs / (1000 * 60 * 60);

      if (totalHours <= 0) {
        showCalcError("Return must be after pickup.");
        return;
      }

      const price = calculateCustomRentalPrice(totalHours);
      const durationText = formatDuration(totalHours);

      showCalcSuccess(price, durationText);
    }

    configurator.querySelectorAll(".rc-option").forEach((option) => {
      option.addEventListener("click", function (event) {
        const group = option.dataset.group;
        const value = option.dataset.value;

        if (!group || !value) return;

        if (group === "customer-type" && value === "Existing Customer" && !isLoggedIn) {
          event.preventDefault();
          openModal();
          return;
        }

        setSelected(group, option);
        answers[group] = value;
        saveProperty(group, value);
        handleConditionalPanels(group, value);

        if (group === "need-type" && value === "Add this item and continue shopping") {
          event.preventDefault();
          persistState();
          window.location.href = "/collections/all";
          return;
        }

        if (group === "receive-method") {
          updateDeliverySummary();
        }

        if (group === "requested-date") {
          syncRequestedDate();
          updateRentalPeriod();
        }

        if (group === "customer-type") {
          updateHomeAddressPreview();
        }

        if (group === "equipment-destination") {
          syncOnsiteContactState();
        }

        if (group === "rental-duration") {
          answers["custom-duration-mode"] = "preset";
          updateCustomDatesPanel();
          updateOvernightPanel();
          updateRentalPeriod();
        }

        persistState();
        autoAdvanceFrom(group);
      });
    });

    if (dateManualInput) {
      dateManualInput.addEventListener("change", function () {
        syncRequestedDate();
        updateRentalPeriod();
        persistState();
      });
    }

    if (timeManualInput) {
      timeManualInput.addEventListener("change", function () {
        syncRequestedTime();
        updateOvernightPanel();
        updateRentalPeriod();
        persistState();
      });
    }

    if (customDatesToggle) {
      customDatesToggle.addEventListener("click", function () {
        answers["custom-duration-mode"] =
          answers["custom-duration-mode"] === "custom" ? "preset" : "custom";

        if (answers["custom-duration-mode"] === "custom") {
          configurator.querySelectorAll('[data-group="rental-duration"]').forEach((item) => {
            item.classList.remove("is-selected");
          });
          answers["rental-duration"] = "";
          saveProperty("rental-duration", "Custom Dates");
        }

        updateCustomDatesPanel();
        updateOvernightPanel();
        updateRentalPeriod();
        persistState();
      });
    }

    if (customStartInput) {
      customStartInput.addEventListener("change", function () {
        updateRentalPeriod();
        persistState();
      });
    }

    if (customEndInput) {
      customEndInput.addEventListener("change", function () {
        updateRentalPeriod();
        persistState();
      });
    }

    if (overnightKeepBtn) {
      overnightKeepBtn.addEventListener("click", function () {
        answers["overnight-option"] = "same-day";
        saveProperty("overnight-option", "Same-Day Return");
        overnightKeepBtn.classList.add("is-selected");
        overnightReturnBtn?.classList.remove("is-selected");
        updateRentalPeriod();
        persistState();
      });
    }

    if (overnightReturnBtn) {
      overnightReturnBtn.addEventListener("click", function () {
        answers["overnight-option"] = "overnight";
        saveProperty("overnight-option", "Return Tomorrow Morning");
        overnightReturnBtn.classList.add("is-selected");
        overnightKeepBtn?.classList.remove("is-selected");
        updateRentalPeriod();
        persistState();
      });
    }

    if (sideCalcButton) {
      sideCalcButton.addEventListener("click", runCustomCalculator);
    }

    if (sideCalcCta) {
      sideCalcCta.addEventListener("click", function () {
        if (form) {
          form.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        syncRequestedDate();
        syncRequestedTime();
        updateDeliverySummary();
        updateCustomDatesPanel();
        updateOvernightPanel();
        updateRentalPeriod();
        updateHomeAddressPreview();
        syncOnsiteContactState();

        if (!validateCurrentStep()) return;
        goToStep(currentStep + 1);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        goToStep(currentStep - 1);
      });
    }

    if (homeContactToggle) {
      homeContactToggle.addEventListener("click", function () {
        homeContactToggle.classList.toggle("is-selected");
        homeContactToggle.setAttribute(
          "aria-pressed",
          homeContactToggle.classList.contains("is-selected") ? "true" : "false"
        );
        syncOnsiteContactState();
        persistState();
      });
    }

    Object.values(newCustomerFields).forEach((field) => {
      field?.addEventListener("input", function () {
        updateHomeAddressPreview();
        persistState();
      });
    });

    Object.values(existingFields).forEach((field) => {
      field?.addEventListener("input", persistState);
    });

    Object.values(onsiteFields).forEach((field) => {
      field?.addEventListener("input", function () {
        syncOnsiteContactHiddenFields();
        persistState();
      });
    });

    if (existingEditToggle) {
      existingEditToggle.addEventListener("click", function () {
        if (existingSummary) existingSummary.hidden = true;
        if (existingEdit) existingEdit.hidden = false;
        persistState();
      });
    }

    if (existingCancelBtn) {
      existingCancelBtn.addEventListener("click", function () {
        if (existingSummary) existingSummary.hidden = false;
        if (existingEdit) existingEdit.hidden = true;
      });
    }

    if (existingSaveBtn) {
      existingSaveBtn.addEventListener("click", function () {
        const invalidField = validateExistingAccountEdit();
        if (invalidField) {
          invalidField.focus();
          return;
        }

        updateExistingSummary();
        updateHomeAddressPreview();
        if (existingSummary) existingSummary.hidden = false;
        if (existingEdit) existingEdit.hidden = true;
        persistState();
      });
    }

    if (loginModal) {
      loginModal.querySelectorAll("[data-login-modal-close]").forEach((button) => {
        button.addEventListener("click", closeModal);
      });
    }

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && loginModal && !loginModal.hidden) {
        closeModal();
      }
    });

    if (loginModal) {
      const loginContinue = loginModal.querySelector("[data-login-continue]");
      loginContinue?.addEventListener("click", persistState);
    }

    if (saveRentalDetailsBtn && form) {
      saveRentalDetailsBtn.addEventListener("click", function () {
        syncRequestedDate();
        syncRequestedTime();
        updateDeliverySummary();
        updateCustomDatesPanel();
        updateOvernightPanel();
        updateRentalPeriod();
        updateHomeAddressPreview();
        updateExistingSummary();
        syncOnsiteContactState();

        for (let stepNumber = 1; stepNumber <= steps.length; stepNumber += 1) {
          currentStep = stepNumber;
          if (!validateCurrentStep()) {
            renderSteps();
            return;
          }
        }

        form.requestSubmit();
      });
    }

    if (form) {
      form.addEventListener("submit", function (event) {
        syncRequestedDate();
        syncRequestedTime();
        updateDeliverySummary();
        updateCustomDatesPanel();
        updateOvernightPanel();
        updateRentalPeriod();
        updateHomeAddressPreview();
        updateExistingSummary();
        syncOnsiteContactState();

        if (!validateCurrentStep()) {
          event.preventDefault();
          return;
        }

        for (let stepNumber = 1; stepNumber <= steps.length; stepNumber += 1) {
          currentStep = stepNumber;
          if (!validateCurrentStep()) {
            event.preventDefault();
            renderSteps();
            return;
          }
        }

        sessionStorage.removeItem(storageKey);
      });
    }

    const params = new URLSearchParams(window.location.search);

    restoreState();

    if (!isLoggedIn && answers["customer-type"] === "Existing Customer") {
      answers["customer-type"] = "New Customer";
      saveProperty("customer-type", "New Customer");
    }

    if (!answers["customer-type"] && !isLoggedIn) {
      answers["customer-type"] = "New Customer";
      saveProperty("customer-type", "New Customer");
    }

    configurator.querySelectorAll(".rc-option").forEach((option) => {
      option.classList.remove("is-selected");
    });
    configurator.querySelector('[data-group="need-type"][data-value="This Is All I Need"]')?.classList.add("is-selected");

    Object.entries(answers).forEach(([group, value]) => {
      if (!value) return;
      const selected = configurator.querySelector(`[data-group="${group}"][data-value="${CSS.escape(value)}"]`);
      if (selected) selected.classList.add("is-selected");
      handleConditionalPanels(group, value);
    });

    if (isLoggedIn && params.get("rc_existing_customer") === "1") {
      selectOptionByValue("customer-type", "Existing Customer");
      currentStep = Math.max(Number(params.get("rc_step") || 3), 3);
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete("rc_existing_customer");
      cleanUrl.searchParams.delete("rc_step");
      window.history.replaceState({}, "", cleanUrl.toString());
    }

    updateExistingSummary();
    updateHomeAddressPreview();
    syncRequestedDate();
    syncRequestedTime();
    updateDeliverySummary();
    updateCustomDatesPanel();
    updateOvernightPanel();
    updateRentalPeriod();
    syncOnsiteContactState();
    saveProperty("overnight-option", answers["overnight-option"] === "overnight" ? "Return Tomorrow Morning" : "Same-Day Return");
    renderSteps();

    const STORAGE_KEYS = {
      wishlist: "rc_wishlist_products",
      compare: "rc_compare_products"
    };

    function getStoredItems(key) {
      try {
        return JSON.parse(localStorage.getItem(key)) || [];
      } catch (error) {
        return [];
      }
    }

    function setStoredItems(key, items) {
      localStorage.setItem(key, JSON.stringify(items));
    }

    function buildProductData(button) {
      return {
        id: String(button.dataset.productId || ""),
        handle: button.dataset.productHandle || "",
        title: button.dataset.productTitle || ""
      };
    }

    function hasItem(items, productId) {
      return items.some((item) => String(item.id) === String(productId));
    }

    function toggleWishlist(button) {
      const product = buildProductData(button);
      let items = getStoredItems(STORAGE_KEYS.wishlist);

      if (hasItem(items, product.id)) {
        items = items.filter((item) => String(item.id) !== String(product.id));
        button.classList.remove("is-active");
        button.setAttribute("aria-pressed", "false");
        button.textContent = "♡";
      } else {
        items.push(product);
        button.classList.add("is-active");
        button.setAttribute("aria-pressed", "true");
        button.textContent = "♥";
      }

      setStoredItems(STORAGE_KEYS.wishlist, items);
    }

    function toggleCompare(button) {
      const product = buildProductData(button);
      let items = getStoredItems(STORAGE_KEYS.compare);

      if (hasItem(items, product.id)) {
        items = items.filter((item) => String(item.id) !== String(product.id));
        button.classList.remove("is-active");
        button.setAttribute("aria-pressed", "false");
      } else {
        if (items.length >= 4) {
          alert("You can compare up to 4 products.");
          return;
        }
        items.push(product);
        button.classList.add("is-active");
        button.setAttribute("aria-pressed", "true");
      }

      setStoredItems(STORAGE_KEYS.compare, items);
    }

    function initActionButtons() {
      const actionButtons = configurator.querySelectorAll(".rc-side-action");

      actionButtons.forEach((button) => {
        const action = button.dataset.action;
        const productId = button.dataset.productId;

        if (!action || !productId) return;

        const storageKeyForAction = STORAGE_KEYS[action];
        const items = getStoredItems(storageKeyForAction);

        if (hasItem(items, productId)) {
          button.classList.add("is-active");
          button.setAttribute("aria-pressed", "true");

          if (action === "wishlist") {
            button.textContent = "♥";
          }
        } else {
          button.setAttribute("aria-pressed", "false");
        }

        button.addEventListener("click", function () {
          if (action === "wishlist") toggleWishlist(button);
          if (action === "compare") toggleCompare(button);
        });
      });
    }

    initActionButtons();
  });
});